/**
 * Style shopify-account sheet close/back controls (shadow DOM).
 */
(function () {
  const STYLE_ID = 'kc-account-sheet-style';

  const CSS = `
    .dialog {
      border-radius: 16px;
      overflow: hidden;
    }

    @media (max-width: 750px) {
      .dialog {
        border-radius: 0;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
    }

    .account {
      border-radius: inherit;
      overflow: hidden;
    }

    .account__close,
    .account__close.button,
    .account__close.button.subdued,
    .account__back-button,
    .account__back-button.button,
    .account__back-button.button.subdued {
      appearance: none;
      -webkit-appearance: none;
      background: transparent !important;
      background-color: transparent !important;
      border: 0 !important;
      border-width: 0 !important;
      outline: none !important;
      box-shadow: none !important;
      filter: none !important;
      color: rgb(from var(--shopify-account-color-text) r g b / 0.55);
      opacity: 1;
      transition: color 0.2s ease, opacity 0.2s ease;
    }

    .account__close:hover,
    .account__close:focus,
    .account__close:focus-visible,
    .account__back-button:hover,
    .account__back-button:focus,
    .account__back-button:focus-visible {
      background: transparent !important;
      background-color: transparent !important;
      border: 0 !important;
      outline: none !important;
      box-shadow: none !important;
      filter: none !important;
      color: var(--shopify-account-color-text);
      opacity: 0.85;
    }
  `;

  function inject(account) {
    const root = account.shadowRoot;
    if (!root) return;

    let style = root.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }
    style.textContent = CSS;
  }

  function bind(account) {
    inject(account);
    account.addEventListener('open', () => inject(account));
  }

  function init() {
    const account = document.querySelector('shopify-account');
    if (!account) return;

    if (account.shadowRoot) {
      bind(account);
      return;
    }

    const observer = new MutationObserver(() => {
      if (!account.shadowRoot) return;
      bind(account);
      observer.disconnect();
    });
    observer.observe(account, { childList: true });
  }

  customElements.whenDefined('shopify-account').then(init);
})();
